<div class="search-filter-container" [formGroup]="form">
    <div class="search-filter-fields">
        @for (searchField of activeSearchFields; track searchField.control) {
        <mat-form-field class="bordered-field">
            <input
                matInput
                [placeholder]="searchField.placeholder | translate"
                [formControlName]="searchField.control"
                (keyup.enter)="triggerSearch()"
            />
            @if (form.get(searchField.control)?.value) {
            <button matSuffix mat-icon-button aria-label="Clear" (click)="resetField(searchField.control)">
                <mat-icon>close</mat-icon>
            </button>
            }
        </mat-form-field>
        }
        <mat-form-field class="bordered-field">
            <mat-label>{{ 'OVERVIEW.DATE_PICKER.PLACEHOLDER' | translate }}</mat-label>
            <mat-date-range-input [rangePicker]="picker" [max]="maxDate">
                <input matStartDate formControlName="start" [max]="form.controls.end.value" />
                <input matEndDate formControlName="end" [max]="maxDate" />
            </mat-date-range-input>
            <button
                *ngIf="form.controls.start.value && form.controls.end.value"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="resetDate()"
            >
                <mat-icon>close</mat-icon>
            </button>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
            @if (form.controls.start.hasError('matDatepickerMax')) {
            <mat-error>
                {{ 'OVERVIEW.DATE_PICKER.MAX_DATE_INVALID' | translate }}
            </mat-error>
            } @if ( !form.controls.start.hasError('matDatepickerMax') && (form.controls.start.invalid ||
            form.controls.end.invalid)) {
            <mat-error>
                {{ 'OVERVIEW.DATE_PICKER.INVALID_DATE' | translate }}
            </mat-error>
            }
        </mat-form-field>
    </div>
    <button (click)="triggerSearch()" mat-raised-button color="primary" [disabled]="!hasAtLeastOneValue()">
        {{ 'OVERVIEW.SEARCH.LABEL' | translate }}
    </button>
</div>
